import type {
  CSSProp,
  FlattenSimpleInterpolation,
  ThemedStyledComponentsModule,
} from 'styled-components';
import * as styledComponents from 'styled-components';

import type { Theme } from './types';

const {
  css,
  createGlobalStyle,
  default: styled,
  keyframes,
  ThemeProvider,
  useTheme: baseUseTheme,
  withTheme,
} = styledComponents as unknown as ThemedStyledComponentsModule<Theme>;

declare module 'react' {
  interface Attributes {
    css?: CSSProp;
  }
}

export type ThemeProps = styledComponents.ThemeProps<Theme>;
export type StyledProps = styledComponents.StyledProps<Theme>;

const useTheme = (): Theme => baseUseTheme();
export {
  createGlobalStyle,
  css,
  type FlattenSimpleInterpolation,
  keyframes,
  styled,
  ThemeProvider,
  useTheme,
  withTheme,
};
